export const SET_USER_INFO = "SET_USER_INFO";
export const SET_TOKEN = "SET_TOKEN";